/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signuptypemultiplechoice3Inputs */

const en_signuptypemultiplechoice3 = /** @type {(inputs: Signuptypemultiplechoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiple choice`)
};

const de_signuptypemultiplechoice3 = /** @type {(inputs: Signuptypemultiplechoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrere Auswahlen`)
};

/**
* | output |
* | --- |
* | "Multiple choice" |
*
* @param {Signuptypemultiplechoice3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signuptypemultiplechoice3 = /** @type {((inputs?: Signuptypemultiplechoice3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signuptypemultiplechoice3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signuptypemultiplechoice3(inputs)
	return de_signuptypemultiplechoice3(inputs)
});
export { signuptypemultiplechoice3 as "signupTypeMultipleChoice" }